// Global packages and components
import { useSanityImages } from '~/hooks'

// Types
import { SanityRefWithAlt } from '~/types'

interface Props {
  image: SanityRefWithAlt
  imageMobile?: SanityRefWithAlt
  imageSize?: 'full' | 'half'
  classNamePic?: string
  classNameImg?: string
}

// Main export
const Picture = ({
  image,
  imageMobile,
  imageSize = 'full',
  classNamePic,
  classNameImg,
}: Props) => {
  // Image fetcher function
  const { urlFor } = useSanityImages()

  // Breakpoint sizes
  const sizeMobile = 640
  const sizeContainer = 1440
  const sizeHalfContainer = sizeContainer / 2

  // Main desktop URL
  const desktopUrl = urlFor(image)
    .width(imageSize == 'half' ? sizeHalfContainer : sizeContainer)
    .auto('format')
    .url()

  // Optional mobile URL
  const mobileUrl = imageMobile
    ? urlFor(imageMobile).width(sizeMobile).auto('format').url()
    : null

  return (
    <picture className={classNamePic ?? 'w-full'}>
      <source
        srcSet={desktopUrl}
        media="(min-width: 768px)"
      />
      <img
        className={classNameImg ?? 'block w-full'}
        src={mobileUrl ? mobileUrl : desktopUrl}
        alt={image?.alt}
        loading="lazy"
      />
    </picture>
  )
}

export default Picture
